import React from 'react';
import Centers from './Centers';

const Book = () => {
  return <Centers />;
};

export default Book;
